import addRoute from '@/router/add-route';

const Coupons = () => import('@/modules/coupons/coupons.vue');
const CouponForm = () => import('@/modules/coupons/coupon-form.vue');
const CouponDetails = () => import('@/modules/coupons/coupon-details.vue');
const CouponsRedemptions = () => import('@/modules/coupons/coupons-redemptions.vue');

const coupons = [
    addRoute({
        name: 'coupons',
        component: Coupons,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-coupon',
        path: '/coupons/add',
        component: CouponForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-coupon',
        path: '/coupons/update/:id',
        component: CouponForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'coupon-details',
        path: '/coupons/:id',
        component: CouponDetails,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'coupons-redemptions',
        component: CouponsRedemptions,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default coupons;
